if (!window.customElements.get('background-color-scroller')) {

  class BackgroundColorScroller extends HTMLElement {
    constructor() {
      super();
      this.scrollTrigger = null;
      this.gsap = null;
      this.isInitialized = false;
      this.scrollDistance = 500;
      this.startColor = null;
      this.endColor = '#ffffff'; // white
    }

    connectedCallback() {
      // Prevent multiple initializations
      if (this.isInitialized) return;
      
      // Get the background color from the attribute
      this.startColor = this.getAttribute('bg-color') || '#000000';
      
      // Wait for GSAP and ScrollTrigger to be ready
      whenReady('gsap', (gsap) => {
        this.gsap = gsap;
        
        whenReady('ScrollTrigger', () => {
          // Add a small delay to ensure everything is ready
          setTimeout(() => {
            if (!this.isInitialized) {
              this.initScroller();
              this.isInitialized = true;
            }
          }, 100);
        });
      });
    }

    initScroller() {

      // this.style.backgroundColor = "#fff";
      
      const section = this.closest('.shopify-section');
      const mainContent = document.getElementById('MainContent');
      const waterRippleMedia = this.querySelector('water-ripple-media');

      if (!section) {
        console.warn('BackgroundColorScroller: No parent section found');
        return;
      }

      if (!mainContent) {
        console.warn('BackgroundColorScroller: #MainContent element not found');
        return;
      }

      // Set initial background color
      mainContent.style.backgroundColor = this.startColor;

      // Clean up any existing ScrollTrigger instances
      if (this.scrollTrigger) {
        this.scrollTrigger.kill();
        this.scrollTrigger = null;
      }

      this.scrollTrigger = this.gsap.to(mainContent, {
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: `+=${this.scrollDistance}`,
          scrub: 1,
          markers: false,
          onUpdate: (self) => {
            // Interpolate between start and end colors based on scroll progress
            const progress = self.progress;
            const interpolatedColor = this.interpolateColor(this.startColor, this.endColor, progress);
            mainContent.style.backgroundColor = interpolatedColor;
            
            // Also fade out water-ripple-media if it exists
            if (waterRippleMedia) {
              const initialOpacity = parseFloat(waterRippleMedia.getAttribute('opacity')) || 0.5;
              const fadeOutOpacity = initialOpacity * (1 - progress);
              waterRippleMedia.style.opacity = fadeOutOpacity;
            }
          }
        }
      });
    }

    interpolateColor(color1, color2, factor) {
      // Simple color interpolation for hex colors
      const hex1 = color1.replace('#', '');
      const hex2 = color2.replace('#', '');
      
      const r1 = parseInt(hex1.substr(0, 2), 16);
      const g1 = parseInt(hex1.substr(2, 2), 16);
      const b1 = parseInt(hex1.substr(4, 2), 16);
      
      const r2 = parseInt(hex2.substr(0, 2), 16);
      const g2 = parseInt(hex2.substr(2, 2), 16);
      const b2 = parseInt(hex2.substr(4, 2), 16);
      
      const r = Math.round(r1 + (r2 - r1) * factor);
      const g = Math.round(g1 + (g2 - g1) * factor);
      const b = Math.round(b1 + (b2 - b1) * factor);
      
      return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    }

    disconnectedCallback() {
      console.log('BackgroundColorScroller disconnected');
      
      // Clean up ScrollTrigger instances
      if (this.scrollTrigger) {
        this.scrollTrigger.kill();
        this.scrollTrigger = null;
      }
      
      this.isInitialized = false;
    }
    
  }
  
  customElements.define('background-color-scroller', BackgroundColorScroller);

}